<div class="h-p-100 flex flex-col">
  <div class="note m-b-20">
    Use this option to create one or more copies of an existing Case. You can choose the stage at
    which to copy data from the source Case.
  </div>
  <mat-form-field class="select-stage" floatPlaceholder="always" floatLabel="always" appearance="outline">
    <mat-label>Select Stage</mat-label>
    <input matInput placeholder="Input" style="display: none"
           particleAnalytics
           analyticsCategory="copy-case-dialog"
           analyticsAction="select-stage-input" required>
    <mat-radio-group class="flex flex-col"
                     aria-label="Select an option"
                     [(ngModel)]="selectedStage"
                     (change)="onStageChanged()"
                     [disabled]="isCaseTypeDisabled"
    >
      <mat-radio-button *ngFor="let stage of stages; let i = index" class="m-b-10"
                        [value]="stage"
                        [disabled]="i > selectedStageId || !availableStages.includes(stage.replace('-', ''))">
        {{stage}}
      </mat-radio-button>
    </mat-radio-group>

  </mat-form-field>
  <form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm">
    <div *ngIf="selectedStage === 'Arrangement' || selectedStage === 'Filing'">
      <mat-form-field appearance="outline" class="flex-1-1-100">
        <mat-label>Reporting Frequencey</mat-label>
        <mat-select formControlName="selectedFiledPeriod">
          <mat-option *ngFor="let filedPeriod of (filedPeriodList$|async)" [value]="filedPeriod">
            {{filedPeriod.filedPeriodTitle}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
      <mat-label>Copy Settings</mat-label>
      <input matInput placeholder="Input" style="display: none"
             particleAnalytics
             analyticsCategory="choice-filter-modal-item-editor"
             analyticsAction="entity-scope-input">

      <ul class="checkbox-container">
        <li>
          <mat-checkbox formControlName="archiveExisting" [disabled]="isArchived">
            <div class="content flex flex-col">
              <span>Archive existing record(s) for this Case</span>
              <span class="description">Existing related records will be archived, but not deleted</span>
            </div>
          </mat-checkbox>
        </li>
        <div *ngIf="isReadOnly">
          <li>
            <mat-checkbox formControlName="caseIdUsedforCorrection">
              <div class="content flex flex-col">
                <span>This Case will be used for re-submission</span>
                <span class="description">Please only select this option if this Case will be used for re-submission. If selected, the following information will be retained:</span>
                <ul>
                  <li>Case ID</li>
                  <li>Arrangement ID</li>
                  <li>Disclosure ID</li>
                </ul>
              </div>
            </mat-checkbox>
          </li>
        </div>
        <li>
          <mat-checkbox formControlName="specifyField">
            <div class="content flex flex-col">
              <span>Let me specify which data to include.</span>
            </div>
          </mat-checkbox>
        </li>
      </ul>

    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%" *ngIf="!isReadOnly">
      <mat-label>Number of Copies</mat-label>
      <input matInput type="number" min="1" max="100" formControlName="copyCount" required>
      <mat-error *ngIf="inputForm.controls['copyCount'].hasError('required')">
        Copy Count is required!
      </mat-error>
      <mat-error
        *ngIf="inputForm.controls['copyCount'].hasError('min') || inputForm.controls['copyCount'].hasError('max')">
        Number of copies can be between 1 and 100
      </mat-error>
    </mat-form-field>
  </form>
</div>
